import sliceCreator from '../../index.jsx';
import {GET_ALL_CROPS} from '../../../constants/index.jsx';
const _getAllCropsAction = sliceCreator('GET_ALL_CROPS', GET_ALL_CROPS, 'get');

const { asyncAction: getAllCropsAction, reducer, clearData: clearGetAllCropsAction } = _getAllCropsAction;

export default reducer;

export {
    getAllCropsAction,
    clearGetAllCropsAction
}